<script>
const ACTIONS_LABEL = "Acciones";
const cellContent = ({
  key,
  item,
  scopedSlots,
  tableComponents,
  createComponent,
  tableFilters = {},
}) => {
  if (scopedSlots[`${key}-cell`]) {
    return scopedSlots[`${key}-cell`]({
      item,
      value: item[key],
    });
  } else if (tableComponents[key]) {
    const { component, bind } = tableComponents[key];
    return createComponent(component, {
      props: bind(item[key]),
    });
  } else if (tableFilters[key]) {
    return tableFilters[key](item[key]);
  }

  return item[key];
};
export default {
  name: "TableRow",

  functional: true,

  props: {
    tableHeaders: {
      type: Object,
      required: true,
    },
    tableComponents: {
      type: Object,
      required: true,
    },
    tableFilters: {
      type: Object,
      required: false,
      default: () => {},
    },
    item: {
      required: true,
    },
    actions: {
      type: Array,
    },
    actionsClass: {
      type: Array,
      default: () => ["md-info", "md-simple"],
    },
    rowClass: {
      type: [Array, Object, String],
      default: "",
    },
    selectable: {
      type: String,
    },
    sortableFields: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {};
  },

  render(h, context) {
    const { props } = context;
    const {
      item,
      selectable,
      sortableFields,
      actions,
      tableHeaders,
      tableComponents,
      tableFilters,
    } = props;
    const { scopedSlots } = context;
    const { "first-cell": firstCellScope } = scopedSlots;
    const firstCell = firstCellScope ? firstCellScope({ item }) : "";

    const actionsCell =
      actions.length > 0
        ? [
            h(
              "md-table-cell",
              {
                props: {
                  "md-label": ACTIONS_LABEL,
                },
              },
              actions
                .filter((action) => !action.showIf || action.showIf(item))
                .map((action) =>
                  h(
                    "md-button",
                    {
                      class: `md-just-icon md-info md-simple table-action`,
                      on: {
                        click() {
                          action.exe(item);
                        },
                      },
                    },
                    [
                      h("md-icon", action.icon),
                      ...(action.tooltip
                        ? [
                            h("md-tooltip", [
                              h("md-icon", action.icon),
                              action.tooltip,
                            ]),
                          ]
                        : []),
                    ]
                  )
                )
            ),
          ]
        : [];

    return h(
      "md-table-row",
      {
        class: props.rowClass,
        props: {
          "md-selectable": selectable,
        },
      },
      [
        // first cell slot
        ...(firstCell ? [firstCell] : []),
        // data cells
        ...Object.entries(tableHeaders).map(([key, header]) =>
          h(
            "md-table-cell",
            {
              props: {
                "md-label": header,
                mdSortBy: sortableFields.includes(key) ? key : undefined,
              },
            },
            [
              cellContent({
                key,
                item,
                scopedSlots,
                tableComponents,
                tableFilters,
                createComponent: h,
              }),
            ]
          )
        ),
        // action cell
        ...actionsCell,
      ]
    );
    //   return `

    //   <slot name="first-cell" :item="item"/>

    //   <md-table-cell :md-label="header"
    //   v-for="(header, key) in tableHeaders" :key="key"
    //   :md-sort-by="sortableFields.includes(key) ? key : undefined">
    //     <component :is="tableComponents[key].component"
    //       v-bind="tableComponents[key].bind(item[key], item)"
    //       v-if="tableComponents[key]">
    //     </component>
    //     <template v-else-if="tableFilters[key]">
    //       {{tableFilters[key](item[key])}}
    //     </template>
    //     <template v-else>
    //       <slot :name="`${key}-cell`" :item="item" :value="item[key]">
    //         {{item[key]}}
    //       </slot>
    //     </template>
    //   </md-table-cell>

    //   <md-table-cell md-label="Acciones" v-if="actions.length">
    //     <md-button
    //       v-for="action in actions"
    //       :key="action.icon"
    //       v-show="!action.showIf || action.showIf(item)"
    //       class="md-just-icon md-info md-simple"
    //       :class="actionsClass"
    //       style="margin-right: 5px"
    //       @click.native="action.exe(item)"
    //     >
    //       <md-icon>{{action.icon}}</md-icon>
    //       <md-tooltip md-direction="top" class="action-tooltip"
    //       v-if="action.tooltip">
    //         <md-icon>{{action.icon}}</md-icon>
    //         {{action.tooltip}}
    //       </md-tooltip>
    //     </md-button>
    //   </md-table-cell>
    // </md-table-row>
    // `
  },
};
</script>

<style lang="css" scoped>
.action-tooltip {
  font-size: 16px;
}

.md-button.table-action {
  min-width: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tables/TableRow.vue